// 是否为对象(下面的方法有依赖，勿删)
export function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

// 是否为空对象(下面的方法有依赖，勿删)
export function isEmptyObject(data) {
  try {
    return JSON.stringify(data) === '{}';
  } catch (e) {
    return false;
  }
}

export function isWeiXin(): boolean {
  const ua = window.navigator.userAgent.toLowerCase();
  const match = ua.match(/MicroMessenger/i);
  if (match === null) {
    return false;
  }
  if (match.includes('micromessenger')) {
    return true;
  }
  return false;
}

interface ISys {
  chrome: null | string | number;
  safari: null | string | number;
}

// 浏览器版本检查
export function browserVersionCheck() {
  const Sys: ISys = {
    chrome: '',
    safari: '',
  };
  const ua = navigator.userAgent.toLowerCase();
  const chromeInfo = ua.match(/chrome\/([\d.]+)/);
  const safariInfo = ua.match(/version\/([\d.]+).*safari/);
  const isPC = !/applewebkit.*mobile.*/.test(ua);
  Sys.chrome = chromeInfo ? chromeInfo[1] : ''; // chrome的版本号
  Sys.safari = safariInfo ? safariInfo[1] : ''; // safari的版本号
  // (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1] :
  //   (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
  //     (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
  //       (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
  //         (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :

  // 都不兼容低版本浏览器
  if (Sys.chrome) {
    if (Number(Sys.chrome.split('.')[0]) < 49) return '此浏览器样式不兼容，请使用高版本的浏览器~\n';
  } else if (Sys.safari) {
    if (Number(Sys.safari.split('.')[0]) < 11) return '此浏览器样式不兼容，请使用高版本的浏览器~\n';
  }

  // C端兼容手机端
  if ((Sys.chrome && isPC) || !isPC) return '';
  return '为保证使用体验，请使用电脑新版Chrome浏览器~\n';
}

export function isIpadCheck() {
  /*
   * ipad环境判断更新
   * iOS pre 13 以前以ua作判断，13后以platform及maxTouchPoints做判断
   */
  const isIPad =
    navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  return isIPad;
  // 作者：CocoaKier
  // 链接：https://juejin.cn/post/6865658712665620494
  // 来源：稀土掘金
  // 著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。
}

// 是否PC环境
export function isPCCheck() {
  const ua = navigator.userAgent.toLowerCase();
  const isPC = !/applewebkit.*mobile.*/.test(ua);
  const isIpad = isIpadCheck();
  if (isIpad) {
    return true;
  }
  return isPC;
}

export function isIframeAndMobile() {
  try {
    const isIframe = window.self !== window.top;
    const isMobile = window.innerWidth < 1024;

    return isIframe && isMobile;
  } catch (e) {
    return false;
  }
}

// 是否在PC端
export const isInPc = isPCCheck();

// TODO
export function getQueryString(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const { search } = window.location;
  if (search) {
    const r = search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return '';
  }
  return '';
}

/**
 * 设置url 参数
 */
export function setQueryString(key, val, removeKeyList = []) {
  // 传进想设置querystring的key和value
  const path = window.location.href.split('?')[0]; // 获取地址栏 "?"后的内容
  const search = window.location.search.substr(1); // 获取地址栏 "?"后的内容
  const query = {};
  if (search) {
    search.split('&').forEach((item) => {
      const arr = item.split('=');
      // eslint-disable-next-line prefer-destructuring
      query[arr[0]] = arr[1];
    });
    if (Array.isArray(removeKeyList) && removeKeyList.length > 0) {
      removeKeyList.forEach((itemKey) => {
        if (itemKey && typeof itemKey === 'string') {
          // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
          delete query[itemKey];
        }
      });
    }
  }
  query[key] = val;
  const queryArr: string[] = [];
  for (const p in query) {
    if (Object.prototype.hasOwnProperty.call(query, p)) {
      queryArr.push(`${p}=${query[p]}`);
    }
  }
  return `${path}?${queryArr.join('&')}`;
}

/**
 * 设置多个url 参数
 * 传进想设置querystring的Object对象，Object包含key和value
 */
export function setManyQueryString(paramsObj, removeKeyList, opt) {
  if (!removeKeyList?.length) {
    removeKeyList = [];
  }
  const search = window.location.search.substr(1); // 获取地址栏 "?"后的内容
  let query = {};
  if (search) {
    search.split('&').forEach((item) => {
      const arr = item.split('=');
      // eslint-disable-next-line prefer-destructuring
      query[arr[0]] = arr[1];
    });
    // 移除需要删除的参数
    if (Array.isArray(removeKeyList) && removeKeyList.length > 0) {
      removeKeyList.forEach((itemKey) => {
        if (itemKey && typeof itemKey === 'string') {
          // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
          delete query[itemKey];
        }
      });
    }
  }
  if (isObject(paramsObj) && !isEmptyObject(paramsObj)) {
    query = Object.assign(query, paramsObj);
  }
  const queryArr: string[] = [];
  for (const p in query) {
    // 移除参数为null或undefined或空字符
    if (
      Object.prototype.hasOwnProperty.call(query, p) &&
      query[p] !== null &&
      query[p] !== undefined &&
      query[p] !== ''
    ) {
      queryArr.push(`${p}=${query[p]}`);
    }
  }
  let queryStr = '';
  if (queryArr && queryArr.length > 0) {
    queryStr = `?${queryArr.join('&')}`;
  }
  const newOpt = { isHasOrigin: true, isHasPathname: true, ...opt };
  const { isHasOrigin, isHasPathname } = newOpt;
  if (isHasOrigin) {
    const path = window.location.href.split('?')[0]; // 获取地址栏 "?"后的内容
    return `${path}${queryStr}`;
  }
  if (!isHasOrigin && isHasPathname) {
    const { pathname } = window.location;
    return `${pathname}${queryStr}`;
  }
  return queryStr;
}

// 获取url上的参数,返回一个对象
export function getUrlParams(url = window.location.href): any {
  const searchReg = /([^&=?]+)=([^&#?]+)/g;
  const urlParams = {};
  let match;
  let value;
  let name;
  // eslint-disable-next-line no-cond-assign
  while ((match = searchReg.exec(url))) {
    // eslint-disable-next-line prefer-destructuring
    name = match[1];
    // eslint-disable-next-line prefer-destructuring
    value = match[2];
    value = value ? decodeURIComponent(value) : '';
    urlParams[name] = value;
  }
  return urlParams;
}

// 是否线上环境
export function isProduction() {
  // @ts-ignore
  return process?.env?.BLOCK_ENV === 'production';
}

// 是否本地开发环境
export function isLocal() {
  // @ts-ignore
  return process?.env?.BLOCK_ENV === 'development';
}

// 过滤对象中的null和undefined
export function filterNullAndUndefined(obj) {
  if (!isObject(obj) || isEmptyObject(obj)) {
    return {};
  }
  const newObj = {};
  Object.keys(obj).forEach((it) => {
    if (obj[it] !== undefined && obj[it] !== null) {
      newObj[it] = obj[it];
    }
  });
  return newObj;
}

export function Object2Query(queryInfo: Object) {
  let queryStr = '';
  if (isObject(queryInfo) && !isEmptyObject(queryInfo)) {
    const queryList: string[] = [];
    for (const key in queryInfo) {
      if (Object.prototype.hasOwnProperty.call(queryInfo, key)) {
        queryList.push(`${key}=${queryInfo[key]}`);
      }
    }
    queryStr = queryList.join('&');
  }
  return queryStr;
}

// 是否为iphone
export function isIphone() {
  const UA = navigator.userAgent;
  return /iphone/gi.test(UA);
}

// 判断ios终端
export function isIos() {
  const u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

// 判断Android终端
export function isAndroid() {
  const u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
}

// 判断哪种浏览器
export function whichBrowserInfo() {
  const ua = window.navigator.userAgent.toLowerCase();
  return {
    isIosChrome: /crios/g.test(ua), // ios Chrome
    isIosFirefox: /fxios/g.test(ua), // ios火狐
    isQQBrowser: /mqqbrowser/g.test(ua), // 是否百度浏览器
    isBaiduBrowser: /baiduboxapp/g.test(ua), // 是否QQ浏览器
    isUCBrowser: /ucbrowser/g.test(ua), // 是否UC浏览器
    isSafariBrowser:
      /safari/g.test(ua) && !/browser/g.test(ua) && !/chrome/g.test(ua) && !/fxios/g.test(ua) && !/crios/g.test(ua), // 是否Safari浏览器
  };
}

// 中国大陆手机号做11位分割
export function addBlankForPhoneNum(phoneNumber) {
  if (typeof phoneNumber !== 'string') {
    return '';
  }
  let _phoneNumber = '';
  _phoneNumber = phoneNumber.replace(/\D/g, '').substring(0, 11);
  if (_phoneNumber.length > 3 && _phoneNumber.length < 8) {
    _phoneNumber = `${_phoneNumber.substr(0, 3)} ${_phoneNumber.substr(3)}`;
  } else if (_phoneNumber.length >= 8) {
    _phoneNumber = `${_phoneNumber.substr(0, 3)} ${_phoneNumber.substr(3, 4)} ${_phoneNumber.substr(7)}`;
  }
  return _phoneNumber;
}

/**
 * @description: 判断是否是超链接
 * @param {string} url
 * @return {boolean}
 */
export function isUrl(url) {
  const exp = /^https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i;
  const objExp = new RegExp(exp);
  return objExp.test(url) === true;
}
